import { useMemo } from 'react';

import { InsuranceProviders } from '../../enums/insurance-providers';

const xCoverClaimUrl = 'https://www.xcover.com/en/claim';

const useInsuranceUrl = (sellerId, insuranceBookingId, insuranceClaimInitiationUrl, insuranceProviderName) =>
  useMemo(() => {
    if (insuranceClaimInitiationUrl) {
      return insuranceClaimInitiationUrl;
    }
    if (insuranceProviderName === InsuranceProviders.XCover.name) {
      return xCoverClaimUrl;
    }
    if (insuranceProviderName === InsuranceProviders.ParcelGuard.name) {
      return `https://app.shipsurance.com/extclaims/?cid=parcelguard&psid=${sellerId}&shipmentid=${insuranceBookingId}`;
    }
    if (insuranceProviderName === InsuranceProviders.Shipsurance.name) {
      return `https://app.shipsurance.com/extclaims/?cid=shipstation&psid=${sellerId}&shipmentid=${insuranceBookingId}`;
    }
  }, [sellerId, insuranceBookingId, insuranceClaimInitiationUrl, insuranceProviderName]);

export { useInsuranceUrl };
